import React from 'react'
import logo from './logo.svg'
import './App.less'
import keycloak from './config/keycloak'
import routes from './routes'
import { renderRoutes } from 'react-router-config'

function App() {
  const authenticated = keycloak?.authenticated ?? false
  const routing = renderRoutes(routes(authenticated))
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        {routing}
      </header>
    </div>
  )
}

export default App
